import React from 'react'
import './contact.css'
import {AiOutlineMail} from 'react-icons/ai'
import {RiMessengerLine} from 'react-icons/ri'
import {FaWhatsapp} from 'react-icons/fa'
import { useRef } from 'react';
import emailjs from 'emailjs-com'


function Contact() {
  const form =  useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_ib843xn', 'template_dxqi92u', form.current, 'y9RidCU6phvR4sIT6')
      e.target.reset()
  };

  return (
    <section id="contact">
      <h5>Get in Touch</h5>
      <h2>Contact Me</h2>

      <div className="container contact-container">
        <div className="contact_options">
        <article className="contact_option">
           <AiOutlineMail className='contact_option-icon'/>
          <h4>Email</h4>
          <h5>mdabrar15009@gmail.com</h5>
          <a href="mailto:mdabrar15009@gmail.com">Send a Message</a>
           </article>

           <article className="contact_option">
           <RiMessengerLine className='contact_option-icon'/>
          <h4>Messenger</h4>
          <h5>MH Abrar</h5>
          <a href="https//m.me/Mh Abrar.achiever">Send a Message</a>
           </article>

           <article className="contact_option">
           <FaWhatsapp className='contact_option-icon'/>
          <h4>Whatsapp</h4>
          <h5>+8801876998621</h5>
          <a href="https://api.whatsapp.com/send?phone+8801876998621">Send a Message</a>
           </article>
           </div>
        {/*End of contact option*/}
        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name='name' placeholder='Your Full name' required />
          <input type="email" name='email' placeholder='Your email' required />
          <textarea name="message"  rows="7" placeholder='Your Message' required></textarea>
          <button type='submit' className='btn btn-primary' required>send message</button>
        </form>

      </div>
      
   </section>
  )
}

export default Contact